import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enInterface from './locales/en/interface.json';
import elInterface from './locales/el/interface.json';
import deInterface from './locales/de/interface.json';
import esInterface from './locales/es/interface.json';
import frInterface from './locales/fr/interface.json';
import nlInterface from './locales/nl/interface.json';
import ptInterface from './locales/pt/interface.json';

// Import translation files
import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enTraining from './locales/en/training.json';
import enPayments from './locales/en/payments.json';
import enBelt from './locales/en/belt.json';
import enForms from './locales/en/forms.json';

import esCommon from './locales/es/common.json';
import esDashboard from './locales/es/dashboard.json';
import esTraining from './locales/es/training.json';
import esPayments from './locales/es/payments.json';
import esBelt from './locales/es/belt.json';
import esForms from './locales/es/forms.json';

import frCommon from './locales/fr/common.json';
import frDashboard from './locales/fr/dashboard.json';
import frTraining from './locales/fr/training.json';
import frPayments from './locales/fr/payments.json';
import frBelt from './locales/fr/belt.json';
import frForms from './locales/fr/forms.json';

import deCommon from './locales/de/common.json';
import deDashboard from './locales/de/dashboard.json';
import deTraining from './locales/de/training.json';
import dePayments from './locales/de/payments.json';
import deBelt from './locales/de/belt.json';
import deForms from './locales/de/forms.json';

import nlCommon from './locales/nl/common.json';
import nlDashboard from './locales/nl/dashboard.json';
import nlTraining from './locales/nl/training.json';
import nlPayments from './locales/nl/payments.json';
import nlBelt from './locales/nl/belt.json';
import nlForms from './locales/nl/forms.json';

import elCommon from './locales/el/common.json';
import elDashboard from './locales/el/dashboard.json';
import elTraining from './locales/el/training.json';
import elPayments from './locales/el/payments.json';
import elBelt from './locales/el/belt.json';
import elForms from './locales/el/forms.json';

import ptCommon from './locales/pt/common.json';
import ptDashboard from './locales/pt/dashboard.json';
import ptTraining from './locales/pt/training.json';
import ptPayments from './locales/pt/payments.json';
import ptBelt from './locales/pt/belt.json';
import ptForms from './locales/pt/forms.json';
import ptAdmin from './locales/pt/admin.json';

// Import admin files for all languages
import enAdmin from './locales/en/admin.json';
import esAdmin from './locales/es/admin.json';
import frAdmin from './locales/fr/admin.json';
import deAdmin from './locales/de/admin.json';
import nlAdmin from './locales/nl/admin.json';
import elAdmin from './locales/el/admin.json';

const resources = {
  en: {
    interface: enInterface,
    common: enCommon,
    dashboard: enDashboard,
    training: enTraining,
    payments: enPayments,
    belt: enBelt,
    forms: enForms,
    admin: enAdmin,
  },
  es: {
    interface: esInterface,
    common: esCommon,
    dashboard: esDashboard,
    training: esTraining,
    payments: esPayments,
    belt: esBelt,
    forms: esForms,
    admin: esAdmin,
  },
  fr: {
    interface: frInterface,
    common: frCommon,
    dashboard: frDashboard,
    training: frTraining,
    payments: frPayments,
    belt: frBelt,
    forms: frForms,
    admin: frAdmin,
  },
  de: {
    interface: deInterface,
    common: deCommon,
    dashboard: deDashboard,
    training: deTraining,
    payments: dePayments,
    belt: deBelt,
    forms: deForms,
    admin: deAdmin,
  },
  nl: {
    interface: nlInterface,
    common: nlCommon,
    dashboard: nlDashboard,
    training: nlTraining,
    payments: nlPayments,
    belt: nlBelt,
    forms: nlForms,
    admin: nlAdmin,
  },
  el: {
    interface: elInterface,
    common: elCommon,
    dashboard: elDashboard,
    training: elTraining,
    payments: elPayments,
    belt: elBelt,
    forms: elForms,
    admin: elAdmin,
  },
  pt: {
    interface: ptInterface,
    common: ptCommon,
    dashboard: ptDashboard,
    training: ptTraining,
    payments: ptPayments,
    belt: ptBelt,
    forms: ptForms,
    admin: ptAdmin,
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'el', 'de', 'es', 'fr', 'nl', 'pt'],
    load: 'languageOnly',
    fallbackNS: 'common',
    react: { nsMode: 'fallback' },
    debug: false,

    defaultNS: 'common',
    // Explicit namespaces must also resolve keys containing spaces or punctuation.
    nsSeparator: ':',
    ns: ['common', 'dashboard', 'training', 'payments', 'belt', 'forms', 'admin', 'interface'],

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'warriorhub-language',
      caches: ['localStorage'],
    },
  });

const updateDocumentLanguage = (language: string) => {
  if (typeof document !== 'undefined') document.documentElement.lang = language.split('-')[0];
};
i18n.on('languageChanged', updateDocumentLanguage);
updateDocumentLanguage(i18n.resolvedLanguage || i18n.language || 'en');

export default i18n;
